<template>
  <div id="documentViewPermission" class="common_contentBox">
    <div class="common_search">
      <el-row>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">查看人</div>
          <div class="content">
            <el-select
              clearable
              v-model="form.userId"
              filterable
              remote
              reserve-keyword
              placeholder="请输入关键词"
              :remote-method="remoteMethod"
              :loading="userLoading"
            >
              <el-option v-for="item in userList" :key="item.userId" :label="item.combination" :value="item.userId" />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6">
          <div class="label">配置类型</div>
          <div class="content">
            <el-select v-model="form.configType" placeholder="请选择" @change="configTypeChange">
              <el-option
                v-for="item in configureTypeList"
                :key="item.code"
                :label="item.val"
                :value="item.code"
              />
            </el-select>
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="8" :lg="6" :xl="6" />
        <div class="btnBar">
          <el-button plain @click="reset">重置</el-button>
          <el-button type="primary" @click="searchBtn">搜索</el-button>
        </div>
      </el-row>
    </div>
    <div class="common_btnBar">
      <el-button type="primary" @click="addHandler">添加</el-button>
    </div>
    <commonTable ref="documentViewPermissionTable" />
    <addEditDialog
      :row-data="rowData"
      :add-edit-dialog-show="addEditDialogShow"
      :config-type="configType"
      @dialogClose="dialogClose"
      @subSuccessHandler="subSuccessHandler"
    />
  </div>
</template>
<script>
import commonTable from '@/components/commonTable';
import { TableRow, TableColumns } from '@/utils/tableOptions';
import { transferOrderApi, documentViewPermissionApi } from './service';
import addEditDialog from './component/documentViewPermission/addEditDialog';

export default {
  data () {
    return {
      form: {
        configType: 1
      },
      tableData: [],
      configureTypeList: [
        {
          code: 1,
          val: '申请部门'
        },
        {
          code: 2,
          val: '费用归属部门'
        },
        {
          code: 3,
          val: '活动申请人'
        },
        {
          code: 4,
          val: '活动单'
        }
      ],
      rowData: {},
      userList: [],
      userLoading: false,
      configType: 1,
      addEditDialogShow: false
    };
  },
  components: {
    commonTable,
    addEditDialog
  },
  methods: {
    subSuccessHandler () {
      this.dialogClose();
      this.searchBtn();
    },
    dialogClose () {
      this.addEditDialogShow = false;
      this.rowData = {};
    },
    editHandlen (row) {
      this.configType = this.form.configType;
      this.rowData = JSON.parse(JSON.stringify(row));
      this.addEditDialogShow = true;
    },
    addHandler () {
      this.configType = this.form.configType;
      this.addEditDialogShow = true;
    },
    editHandler (row) {
      this.editData = JSON.parse(JSON.stringify(row));
    },
    remoteMethod (query) {
      if (query && query.indexOf(' ') === -1) {
        this.userLoading = true;
        transferOrderApi.getAllSalesmanList(query).then(res => {
          if (res.status === '200') {
            if (res.data && res.data.length > 0) {
              this.userList = res.data.map(item => {
                return {
                  ...item,
                  combination: `${item.userName}/${item.deptName}`
                };
              });
            } else {
              this.userList = [];
            }
          }
          this.userLoading = false;
        });
      }
    },
    deleteHandle (row) {
      this.$confirm('确定删除此配置?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (this.form.configType === 1 || this.form.configType === 2) {
          // 可查看部门删除
          documentViewPermissionApi.deptDelete(row.id).then(res => {
            if (res.status === '200') {
              this.$message.success('删除成功');
              this.searchBtn();
            }
          });
        } else {
          // 可查看用户删除
          documentViewPermissionApi.userDelete(row.id).then(res => {
            if (res.status === '200') {
              this.$message.success('删除成功');
              this.searchBtn();
            }
          });
        }
      }).catch(() => {

      });
    },
    configTypeChange () {
      this.$refs.documentViewPermissionTable.pageData.pageNum = 1;
      this.loadTable();
    },
    reset () {
      this.form = {
        configType: 1
      };
      this.searchBtn();
    },
    searchBtn () {
      this.$refs.documentViewPermissionTable.pageData.pageNum = 1;
      this.loadTable();
    },
    loadTable () {
      let tempForm = {
        userId: this.form.userId
      };
      switch (this.form.configType) {
        case 1:
          tempForm.visibleDeptType = '申请部门';
          this.loadCostApplyTable(tempForm);
          break;
        case 2:
          tempForm.visibleDeptType = '费用归属部门';
          this.loadCostAscriptionTable(tempForm);
          break;
        case 3:
          tempForm.type = 1;
          this.loadActivityApplyTable(tempForm);
          break;
        default:
          tempForm.type = 2;
          this.loadActivityListTable(tempForm);
      }
    },
    loadCostApplyTable (data) {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title('查看人')
          ._width('150px')
          ._data('userName')
      );
      tableRow.push(
        new TableColumns()
          ._title('申请部门')
          ._width('200px')
          ._data('deptName')
      );
      tableRow.push(
        new TableColumns()
          ._title('操作')
          ._width('120px')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <el-button type="text" onClick={() => {
                    this.editHandlen(row);
                  }}>编辑
                  </el-button>
                  <el-button type="text" onClick={() => {
                    this.deleteHandle(row);
                  }}>删除
                  </el-button>
                </div>
              );
            }
          })
      );
      let column = tableRow._cols();
      this.$refs.documentViewPermissionTable.setColumn(column);
      this.$refs.documentViewPermissionTable.loadTable({ url: '/management/visible-dept-list', listKey: 'list', params: data });
    },
    loadCostAscriptionTable (data) {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title('查看人')
          ._width('8%')
          ._data('userName')
      );
      tableRow.push(
        new TableColumns()
          ._title('费用归属部门')
          ._width('10%')
          ._data('deptName')
      );
      tableRow.push(
        new TableColumns()
          ._title('操作')
          ._width('6%')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <el-button type="text" onClick={() => {
                    this.editHandlen(row);
                  }}>编辑
                  </el-button>
                  <el-button type="text" onClick={() => {
                    this.deleteHandle(row);
                  }}>删除
                  </el-button>
                </div>
              );
            }
          })
      );
      let column = tableRow._cols();
      this.$refs.documentViewPermissionTable.setColumn(column);
      this.$refs.documentViewPermissionTable.loadTable({ url: '/management/visible-dept-list', listKey: 'list', params: data });
    },
    loadActivityApplyTable (data) {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title('查看人')
          ._width('10%')
          ._data('userName')
      );
      tableRow.push(
        new TableColumns()
          ._title('活动申请人')
          ._width('10%')
          ._data('applyUserName')
      );
      tableRow.push(
        new TableColumns()
          ._title('操作')
          ._width('6%')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <el-button type="text" onClick={() => {
                    this.editHandlen(row);
                  }}>编辑
                  </el-button>
                  <el-button type="text" onClick={() => {
                    this.deleteHandle(row);
                  }}>删除
                  </el-button>
                </div>
              );
            }
          })
      );
      let column = tableRow._cols();
      this.$refs.documentViewPermissionTable.setColumn(column);
      this.$refs.documentViewPermissionTable.loadTable({ url: '/management/visible-user-list', listKey: 'list', params: data });
    },
    loadActivityListTable (data) {
      let tableRow = new TableRow();
      tableRow.push(
        new TableColumns()
          ._title('查看人')
          ._width('8%')
          ._data('userName')
      );
      tableRow.push(
        new TableColumns()
          ._title('活动单')
          ._width('8%')
          ._data('activityCode')
      );
      tableRow.push(
        new TableColumns()
          ._title('操作')
          ._width('6%')
          ._cellType('customDom')
          ._cellData({
            formater: ({ row, column }) => {
              return (
                <div>
                  <el-button type="text" onClick={() => {
                    this.editHandlen(row);
                  }}>编辑
                  </el-button>
                  <el-button type="text" onClick={() => {
                    this.deleteHandle(row);
                  }}>删除
                  </el-button>
                </div>
              );
            }
          })
      );
      let column = tableRow._cols();
      this.$refs.documentViewPermissionTable.setColumn(column);
      this.$refs.documentViewPermissionTable.loadTable({ url: '/management/visible-user-list', listKey: 'list', params: data });
    }
  },
  mounted () {
    this.loadTable();
  }
};
</script>
<style lang="scss" scoped>
#documentViewPermission {
  width: 100%;

  .common_button {
    margin-bottom: 16px;
  }
}
</style>
